<template>
  <DeckPlan
    :inspection-config="inspectionConfig"
    :snack-bar-type="snackBarType"
    :snack-bar-text="snackBarText"
    :filter-params="filterParams"
    :extra-equipment-text="extraEquipmentText"
    @onSnackbarDisplay="handleSnackbarDisplay"
    @onSnackbarClose="handleSnackbarClose"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { notificationType } from '@/components/widgets';
import DeckPlan from './DeckPlan.vue';

export default {
  name: 'DeckPlanContainer',
  components: {
    DeckPlan,
  },
  data() {
    return {
      snackBarType: notificationType.none,
      snackBarText: '',
    };
  },
  computed: mapGetters({
    filterParams: 'config/filterParams',
    inspectionConfig: 'config/inspectionConfig',
    extraEquipmentText: 'config/clientExtraEquipmentText',
  }),
  methods: {
    handleSnackbarDisplay(message, type = notificationType.message) {
      this.snackBarType = type;
      this.snackBarText = message;
    },
    handleSnackbarClose() {
      this.snackBarType = notificationType.none;
    },
  },
};
</script>
